import CompanyContacts from './CompanyContacts'

export default CompanyContacts
